<template>
  <v-row>
    <Can I="readAll" a="SalesNote">
      <v-col cols="12" md="6">
          <v-card class="trends-chart-card" elevation="1">
            <v-card-title class="chart-title">
              <div class="d-flex align-center">
                <v-icon class="mr-2" color="#1a73e8">mdi-account-group</v-icon>
                <span class="text-h6 font-weight-medium">Top 5 Clientes</span>
              </div>
            </v-card-title>
            
            <v-card-text class="pa-4">
              <!-- Skeleton mientras carga -->
              <div v-if="loading" class="ga-table">
                <div class="ga-header">
                  <div class="ga-rank">#</div>
                  <div class="ga-name">Cliente</div>
                  <div class="ga-value">Confirmado</div>
                  <div class="ga-value">Facturado</div>
                </div>
                <div 
                  v-for="i in 5" 
                  :key="i"
                  class="ga-row"
                >
                  <div class="ga-rank">
                    <v-skeleton-loader type="text" width="20" height="16"></v-skeleton-loader>
                  </div>
                  <div class="ga-name">
                    <v-skeleton-loader type="text" width="100%" height="16"></v-skeleton-loader>
                  </div>
                  <div class="ga-value">
                    <v-skeleton-loader type="text" width="80" height="16"></v-skeleton-loader>
                  </div>
                  <div class="ga-value">
                    <v-skeleton-loader type="text" width="80" height="16"></v-skeleton-loader>
                  </div>
                </div>
              </div>
              
              <!-- Datos reales -->
              <div v-else class="ga-table">
                <div class="ga-header">
                  <div class="ga-rank">#</div>
                  <div class="ga-name">Cliente</div>
                  <div class="ga-value">Confirmado</div>
                  <div class="ga-value">Facturado</div>
                </div>
                
                <!-- Mostrar datos si existen -->
                <template v-if="topCustomersList.length > 0">
                  <div 
                    v-for="(customer, index) in topCustomersList" 
                    :key="index"
                    class="ga-row"
                  >
                    <div class="ga-rank">{{ index + 1 }}</div>
                    <div class="ga-name">{{ customer.name }}</div>
                    <div class="ga-value">{{ customer.confirmed | moneda }}</div>
                    <div class="ga-value">{{ customer.invoiced | moneda }}</div>
                  </div>
                </template>
                
                <!-- Mensaje cuando no hay datos -->
                <div v-else class="ga-empty-state">
                  <v-icon color="#9aa0a6" size="48" class="mb-3">mdi-database-off</v-icon>
                  <div class="ga-empty-text">No hay datos de clientes para mostrar</div>
                  <div class="ga-empty-subtext">No se encontraron transacciones en el período seleccionado</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </Can>
      
      <Can I="readAll" a="SalesNote">
        <v-col cols="12" md="6">
          <v-card class="trends-chart-card" elevation="1">
            <v-card-title class="chart-title">
              <div class="d-flex align-center">
                <v-icon class="mr-2" color="#1a73e8">mdi-account-tie</v-icon>
                <span class="text-h6 font-weight-medium">Top 5 Vendedores</span>
              </div>
            </v-card-title>
            
            <v-card-text class="pa-4">
              <!-- Skeleton mientras carga -->
              <div v-if="loading" class="ga-table">
                <div class="ga-header">
                  <div class="ga-rank">#</div>
                  <div class="ga-name">Vendedor</div>
                  <div class="ga-value">Confirmado</div>
                  <div class="ga-value">Facturado</div>
                </div>
                <div 
                  v-for="i in 5" 
                  :key="i"
                  class="ga-row"
                >
                  <div class="ga-rank">
                    <v-skeleton-loader type="text" width="20" height="16"></v-skeleton-loader>
                  </div>
                  <div class="ga-name">
                    <v-skeleton-loader type="text" width="100%" height="16"></v-skeleton-loader>
                  </div>
                  <div class="ga-value">
                    <v-skeleton-loader type="text" width="80" height="16"></v-skeleton-loader>
                  </div>
                  <div class="ga-value">
                    <v-skeleton-loader type="text" width="80" height="16"></v-skeleton-loader>
                  </div>
                </div>
              </div>
              
              <!-- Datos reales -->
              <div v-else class="ga-table">
                <div class="ga-header">
                  <div class="ga-rank">#</div>
                  <div class="ga-name">Vendedor</div>
                  <div class="ga-value">Confirmado</div>
                  <div class="ga-value">Facturado</div>
                </div>
                
                <!-- Mostrar datos si existen -->
                <template v-if="topSellersList.length > 0">
                  <div 
                    v-for="(seller, index) in topSellersList" 
                    :key="index"
                    class="ga-row"
                  >
                    <div class="ga-rank">{{ index + 1 }}</div>
                    <div class="ga-name">{{ seller.name }}</div>
                    <div class="ga-value">{{ seller.confirmed | moneda }}</div>
                    <div class="ga-value">{{ seller.invoiced | moneda }}</div>
                  </div>
                </template>
                
                <!-- Mensaje cuando no hay datos -->
                <div v-else class="ga-empty-state">
                  <v-icon color="#9aa0a6" size="48" class="mb-3">mdi-database-off</v-icon>
                  <div class="ga-empty-text">No hay datos de vendedores para mostrar</div>
                  <div class="ga-empty-subtext">No se encontraron transacciones en el período seleccionado</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </Can>
    </v-row>
</template>

<script>


const numeral = require('numeral');
const moment = require('moment')
export default {
  name:'DayGraphComplete',

  props:['customers','sellers','loading'],
  data:()=>({
    topCustomersList: [],
    topSellersList: [],
  }),
  methods:{
    processData(){
      // Verificar que los datos existen
      if (!this.customers || !this.customers[0] || !this.customers[1] || 
          !this.sellers || !this.sellers[0] || !this.sellers[1]) {
        console.log('DayGraphComplete - Datos no disponibles:', { customers: this.customers, sellers: this.sellers })
        return
      }
      
      // Procesar datos de clientes
      const customerDataSet = this.customers[0].map(customer => {
        const invoicedCustomer = this.customers[1].find(c => c.customer__id === customer.customer__id)
        return {
          id: customer.customer__id,
          name: customer.name,
          confirmed: customer.total,
          invoiced: invoicedCustomer ? invoicedCustomer.total : 0
        }
      })
      
      // Procesar datos de vendedores
      const sellerDataSet = this.sellers[0].map(seller => {
        const invoicedSeller = this.sellers[1].find(s => s.customer__seller__id === seller.customer__seller__id)
        return {
          id: seller.customer__seller__id,
          name: seller.full_name,
          confirmed: seller.total,
          invoiced: invoicedSeller ? invoicedSeller.total : 0
        }
      })
      
      // Ordenar por confirmado y tomar top 5
      this.topCustomersList = customerDataSet
        .sort((a, b) => b.confirmed - a.confirmed)
        .slice(0, 5)
      
      this.topSellersList = sellerDataSet
        .sort((a, b) => b.confirmed - a.confirmed)
        .slice(0, 5)
      
      console.log('DayGraphComplete - Datos procesados:', {
        customers: this.topCustomersList,
        sellers: this.topSellersList
      })
    },
  },
  mounted() {
    // Siempre procesar datos de prueba
    this.processData()
  },
  watch:{
    //Revisa cambios en options para solicitar data nuevamente
    customers:{
      deep: true,
      handler: 'processData'
    },
    sellers:{
      deep: true,
      handler: 'processData'
    },
  },
}
</script>

<style scoped>
/* Estilos de las tarjetas de gráficos - Google Analytics 4 style */
.trends-chart-card {
  border-radius: 16px;
  border: 1px solid #e8eaed;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.trends-chart-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.chart-title {
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #f1f3f4;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 16px 16px 0 0;
}

/* Estilos de la tabla - Google Analytics 4 style */
.ga-table {
  width: 100%;
}

.ga-header {
  display: grid;
  grid-template-columns: 40px 1fr 120px 120px;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #e8eaed;
  font-weight: 600;
  font-size: 0.875rem;
  color: #5f6368;
}

.ga-row {
  display: grid;
  grid-template-columns: 40px 1fr 120px 120px;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #f1f3f4;
  align-items: center;
  transition: background-color 0.2s ease;
}

.ga-row:hover {
  background-color: #f8f9fa;
}

.ga-rank {
  font-weight: 500;
  font-size: 0.875rem;
  color: #9aa0a6;
  text-align: center;
}

.ga-name {
  font-weight: 500;
  font-size: 0.875rem;
  color: #202124;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

 .ga-value {
   font-weight: 600;
   font-size: 0.875rem;
   color: #202124;
   text-align: right;
 }
 
 /* Estado vacío - Google Analytics 4 style */
 .ga-empty-state {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   padding: 48px 24px;
   text-align: center;
 }
 
 .ga-empty-text {
   font-size: 1rem;
   font-weight: 500;
   color: #5f6368;
   margin-bottom: 8px;
 }
 
 .ga-empty-subtext {
   font-size: 0.875rem;
   color: #9aa0a6;
   line-height: 1.4;
 }

/* Responsive */
@media (max-width: 768px) {
  .chart-title {
    padding: 16px 16px 0 16px;
  }
  
  .ga-header {
    grid-template-columns: 30px 1fr 100px 100px;
    gap: 12px;
    font-size: 0.8rem;
  }
  
  .ga-row {
    grid-template-columns: 30px 1fr 100px 100px;
    gap: 12px;
    font-size: 0.8rem;
  }
  
  .ga-name {
    font-size: 0.8rem;
  }
  
  .ga-value {
    font-size: 0.8rem;
  }
}
</style>

